module.exports = {
  /*
    Currently this bundleVersion value needs to be manually updated to match the current
    uploaded version. However this whole process should be automated eventually.
  */
  bundleVersion: "1.0.0-simmons-general",
};
